export default __webpack_public_path__ + "static/media/bean-product-mobile.81e8b1be.webp";